const ReportTemplateGroupCalculation = (data) => {
  const { group_data, group_label, key, list_data, report_type } = data;

  let count = 0;
  if (list_data) {
    count = list_data.length;
  }
  data.group_count = count;

  return data;
};

export default ReportTemplateGroupCalculation;
